export default "Spil følelses-banko i klassen og sæt fokus på følelser og de tilhørende ansigtsudtryk.";